import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { TINYMCE_EDITOR_CONFIG } from 'app/shared/editor-config';
import { BulletinVM, BulletinCityVM, BulletinGradeLevelVM, GradeLevels, BulletinSchoolVM } from '../bulletin';

@Component({
  selector: 'app-edit-bulletin',
  templateUrl: './edit-bulletin.component.html',
  styleUrls: ['./edit-bulletin.component.scss']
})
export class EditBulletinDialogComponent implements OnInit {
  selectedAudience = 'All';
  creating: boolean;
  dialogTitle = 'Edit Bulletin';
  bulletin: BulletinVM;
  bulletinForm: FormGroup;
  editorConfig = TINYMCE_EDITOR_CONFIG;

  schools: BulletinSchoolVM[] = [];
  gradeLevels: BulletinGradeLevelVM[] = GradeLevels; 
  cities: BulletinCityVM[] = [];

  @ViewChild("byGradeLevel") gradeLevelList: MatSelectionList;
  @ViewChild("byCity") cityList: MatSelectionList;
  @ViewChild("bySchool") schoolList: MatSelectionList;

  constructor(
        private dialogRef: MatDialogRef<EditBulletinDialogComponent>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: { bulletin: BulletinVM; cities: BulletinCityVM[]; creating: boolean; dialogTitle: string; schools: BulletinSchoolVM[]; }
    ) {
        this.bulletin = data.bulletin;
        this.schools = data.schools;
        this.cities = data.cities;
        this.creating = data.creating;
        this.dialogTitle = data.dialogTitle;
    }

    ngOnInit(): void {
        this.bulletinForm = this.formBuilder.group({
            Message: [this.bulletin.message],
            Type: [this.bulletin.type],
            StartDate: [this.bulletin.startDate],
            EndDate: [this.bulletin.endDate],
            // StartTime: [this.bulletin.startTime],
            // EndTime: [this.bulletin.endTime],
            Active: [this.bulletin.active],
            Title: [this.bulletin.title],
            // Link: [this.bulletin.link],
            // BulletinSchool: [this.bulletin.bulletinSchool],
            Schools: [this.schools],
            Cities: [this.cities],
            GradeLevels: [this.gradeLevels],
            AllSchools: [this.bulletin.allSchools],
            ByGradeLevel: [this.bulletin.byGradeLevel],
            ByCity: [this.bulletin.byCity],
            BySchool: [this.bulletin.bySchool],
        });
    }

    compareFn(o1: any, o2: any): boolean {
        return o1.checked !== o2.checked;
    }

    onSelection(event) {
        event.option.value.checked = event.option.selected;
      }
    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues): void {
        const creating = this.creating;
        this.bulletinForm.markAllAsTouched();

        if (this.bulletinForm.valid) {

            // If creating a new bulletin, check each selection list based on the selected audience (by Grade Leve, by City, etc...)
            // then assign those values to their respective properties on the bulletin.
            if (creating) {
                const allSchools = this.selectedAudience === "All";
                const byGradeLevel = this.selectedAudience !== "GradeLevel";
                const byCity = this.selectedAudience !== "City";
                const bySchool = this.selectedAudience !== "School";
                this.bulletin.allSchools = allSchools;
                this.bulletin.cities = this.bulletin.cities;
                this.bulletin.gradeLevels = this.bulletin.gradeLevels;
                this.bulletin.byGradeLevel = byGradeLevel;
                this.bulletin.byCity = byCity;
                this.bulletin.bySchool = bySchool;
            }
            else {
                const allSchools = this.bulletin.schools.some(school => school.checked === false);
                this.bulletin.allSchools = allSchools;
            }

            // this.bulletin.BulletinId = formValues.BulletinId;
            this.bulletin.message = formValues.Message;
            this.bulletin.type = formValues.Type;
            this.bulletin.startDate = formValues.StartDate;
            this.bulletin.endDate = formValues.EndDate;
            // this.bulletin.startTime = formValues.StartTime;
            // this.bulletin.endTime = formValues.EndTime;
            this.bulletin.active = formValues.Active;
            this.bulletin.title = formValues.Title;
            // this.bulletin.link = formValues.Link;
            // this.bulletin.bulletinSchool = formValues.BulletinSchool;
            this.bulletin.schools = this.bulletin.schools;

            this.dialogRef.close(this.bulletin);
            this.bulletinForm.reset();
        }
    }

    toggleAudience(change: MatButtonToggleChange): void {
        this.selectedAudience = change.value;
    
        if (this.selectedAudience !== "GradeLevel") { 
            this.gradeLevelList.deselectAll();
            this.bulletin.gradeLevels.forEach( gl => gl.checked = false);
        };
        if (this.selectedAudience !== "City") { 
            this.cityList.deselectAll();
            this.bulletin.cities.forEach( gl => gl.checked = false);
        }
        if (this.selectedAudience !== "School") { 
            this.schoolList.deselectAll();
            this.bulletin.schools.forEach( gl => gl.checked = false);
        }
    }

}
